export default function() {
  const accordian = document.querySelector('.accordian');
  let menuBtn, collapse, aria, btnID, cardID;

  accordian.addEventListener('click', function(event) {
    btnID = event.target.id;
    cardID = event.target.parentNode.parentNode.lastElementChild.id;

    if (!btnID) {
      return false;
    }

    menuBtn = document.querySelector('#' + btnID);
    collapse = document.querySelector('#' + cardID);
    aria = collapse.getAttribute('aria-expanded');

    if (collapse.classList.value === 'collapse' && aria === 'false') {
      menuBtn.classList.add('active');
      aria = 'true';
      collapse.setAttribute('aria-expanded', 'true');

      addHeight(aria);

      collapse.classList.remove('collapse');
      collapse.classList.add('collapsing');
    } else if (
      collapse.classList.value === 'collapse show' &&
      aria === 'true'
    ) {
      menuBtn.classList.remove('active');
      aria = 'false';
      collapse.setAttribute('aria-expanded', 'false');

      addHeight(aria);

      collapse.classList.remove('show');
      collapse.classList.remove('collapse');
      collapse.classList.add('collapsing');
    }

    transitionend(collapse, aria);
  });

  let addHeight = function(aria) {
    collapse.style.height = collapse.scrollHeight + 'px';

    setTimeout(() => {
      if (aria === 'false') {
        collapse.style.height = '0px';
      } else {
        collapse.style.height = collapse.scrollHeight + 'px';
      }
    }, 30);
  };

  let transitionend = function(collapse, aria) {
    collapse.addEventListener('transitionend', function(e) {
      if (e.propertyName === 'height' && aria === 'true') {
        collapse.classList.remove('collapsing');
        collapse.classList.add('collapse');
        collapse.classList.add('show');
        collapse.style.height = '';
      } else if (e.propertyName === 'height' && aria === 'false') {
        // console.log('false');
        collapse.classList.remove('show');
        collapse.classList.remove('collapsing');
        collapse.classList.add('collapse');
        collapse.style.height = '';
      }
    });
  };
}
